import makeRequest from 'utils/makeRequest'
import { ENDPOINTS } from 'config/apiEndpoints'
import IDepartmentResponse from 'models/Department/IDepartment'

export const departmentService = {
  getDepartments: async (): Promise<IDepartmentResponse> => {
    try {
      const response: IDepartmentResponse = await makeRequest(
        'GET',
        ENDPOINTS.Department.GetDepartments
      )

      return response
    } catch (error) {
      throw new Error(`Get departments data failed: ${error}`)
    }
  },
  getDepartmentDetails: async (slug: string): Promise<IDepartmentResponse> => {
    try {
      const response: IDepartmentResponse = await makeRequest(
        'GET',
        `${ENDPOINTS.Department.GetDepartmentDetailsPrefix}${slug}${ENDPOINTS.Department.GetDepartmentDetailsSuffix}`
      )

      return response
    } catch (error) {
      console.error(error)
      throw new Error('Get department details failed')
    }
  },
}
